import React, { useState, useEffect } from "react";
import Spinner from "../../components/helpers/Spinner";
import ResponsiveModalAbsolute from "../../components/ResponsiveModalAbsolute";

import { fetchAxiosToken } from "../../helpers/fetchAxiosToken";

import { registerLocale } from "react-datepicker";

import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import Swal from "sweetalert2";
import { Habitacion } from "../../components/helpers/types/modal_habitacion";

interface Fechas {
    fecha: string;
    motivo: string;
}
export interface Selected {
    price: string;
    date: string;
    fechaNoDisponible: Fechas | false;
}

interface Props {
    setModalVisiblePrice: (modalVisiblePrice: boolean) => void;
    modalVisiblePrice: boolean;
    id_habitacion: number;
    nombre: string;
    getAllCasas: (query: string) => void;
}

export const ModalCloneHabitacion = ({
    id_habitacion,
    setModalVisiblePrice,
    modalVisiblePrice,
    nombre,
    getAllCasas,
}: Props) => {
    registerLocale("es", es);
    console.log(id_habitacion, `${nombre}_copy`);
    const [saving, setSaving] = useState<boolean>(false);
    const [nombreHabitacion, setNombreHabitacion] = useState<string>("");

    useEffect(() => {
        if (nombre) {
            setNombreHabitacion(`${nombre}_copy`);
        }
    }, [modalVisiblePrice]);

    const handleSubmit = async () => {
        if (nombreHabitacion === "") {
            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Error",
                text: "Para clonar la habitacion debe ingresar un nombre",
                icon: "error",
                confirmButtonText: "Ok",
            });
            return;
        }
        setSaving(true);
        try {
            const data = await fetchAxiosToken({
                url: `/hotel_habitaciones/clonarHabitacion`,
                method: "post",
                body: {
                    id_habitacion,
                    nombre: nombreHabitacion,
                },
            });

            Swal.fire({
                confirmButtonColor: "#029BFC",
                iconColor: "#029BFC",
                title: "Actualizada",
                text: "Habitación copiada con éxito",
                icon: "success",
                confirmButtonText: "Ok",
            });
            getAllCasas("Todos");
            setSaving(false);
        } catch (error: any) {
            console.log(error.response);
        }
    };

    return (
        <ResponsiveModalAbsolute
            modalVisible={modalVisiblePrice}
            setModalVisible={setModalVisiblePrice}
        >
            <div className="flex flex-col items-center max-w-lg gap-4 p-4 mx-auto ">
                <div className="relative z-20 flex items-center justify-center">
                    <h2 className="mr-1 text-base font-medium">
                        Clonar habitación {nombre}
                    </h2>
                </div>
                <hr className="w-full bg-gray-300" />

                <div className="flex flex-col mt-1  text-[#3C3C3C] w-2/3">
                    <div className="flex  mx-auto w-full">
                        <div className="flex flex-col gap-2 items-center justify-start w-full">
                            <label className="ml-1 text-base font-semibold ">
                                Nombre nueva habitación:
                            </label>
                            <input
                                className="md:ml-3 p-2 w-full pt-[9.5px] rounded-lg border border-[#E9E9E9] outline-none placeholder:text-center "
                                value={nombreHabitacion}
                                type="text"
                                name="nuevaHabitacion"
                                onChange={(e) =>
                                    setNombreHabitacion(e.target.value)
                                }
                            />
                        </div>
                    </div>
                </div>

                <div className="flex flex-col gap-4 mt-8">
                    {saving ? (
                        <Spinner />
                    ) : (
                        <button
                            onClick={() => handleSubmit()}
                            className="p-3 px-5 text-white border rounded-lg bg-[#029BFC] hover:scale-105"
                        >
                            Clonar Habitación
                        </button>
                    )}
                </div>
            </div>
        </ResponsiveModalAbsolute>
    );
};
